import React from 'react';

import WsIconProps from './IconProps';

const ActiveJob: React.FC<WsIconProps> = ({
  color = '#48CAE4',
  color2 = '#00B4D8',
  width = 24,
  height = 25,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8327 5H4.16602C2.78531 5 1.66602 6.11929 1.66602 7.5V9.76739L7.36385 11.6667H12.6348L18.3327 9.76739V7.5C18.3327 6.11929 17.2134 5 15.8327 5Z"
      fill={color}
    />
    <path
      d="M8.33268 5V4.16667H11.666V5H13.3327V4.16667C13.3316 3.24662 12.5861 2.50105 11.666 2.5H8.33268C7.41264 2.50105 6.66707 3.24662 6.66602 4.16667V5H8.33268ZM7.36385 11.6667L1.66602 9.76736V15C1.66752 16.3801 2.78592 17.4985 4.16602 17.5H15.8327C17.2128 17.4985 18.3312 16.3801 18.3327 15V9.76736L12.6348 11.6667H7.36385Z"
      fill={color2}
    />
  </svg>
);

export default ActiveJob;
